// Development routes (/dev/map, /dev/story): the wave-1 demos inside the real shell, so they are judged in context.
import { useNavigate } from 'react-router';
import { Shell } from '../shell/Shell.tsx';
import MapDemo from './MapDemo.tsx';
import StoryDemo from './StoryDemo.tsx';

export function Dev({ demo }: { demo: 'map' | 'story' }) {
  const navigate = useNavigate();
  return (
    <Shell search={{ value: '', onSubmit: (q) => navigate(`/s?${new URLSearchParams({ q })}`), size: 'compact' }}>
      {demo === 'map' ? <MapDemo /> : <StoryDemo />}
    </Shell>
  );
}
